import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = o((e, r) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: r,
    ...e,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3672",
              width: 9,
              height: 13,
              x: 4,
              y: 1,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "m11.713 7.3-6.5-5.14a.747.747 0 1 0-.93 1.17l5.78 4.57-5.65 4.77c-.32.27-.36.74-.09 1.06.16.18.37.27.58.27.17 0 .34-.06.48-.18l6.35-5.36a.73.73 0 0 0 .27-.58c0-.23-.11-.44-.29-.58"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3672)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M1 1h14.515v14.515H1z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyChevronIcon";
export {
  i as AgencyChevronIcon,
  i as default
};
//# sourceMappingURL=index.js.map
